tinymce.addI18n("ro", {
    "#": "",
    "Accessibility": "Accesibilitate",
    "Accordion": "",
    "Accordion body...": "",
    "Accordion summary...": "",
    "Action": "Ac\u0163iune",
    "Activity": "Activit\u0103\u021bi",
    "Address": "Adres\u0103",
    "Advanced": "Complex",
    "Align": "Aliniere",
    "Align center": "Aliniere centru",
    "Align left": "Aliniere st\xe2nga",
    "Align right": "Aliniere dreapta",
    "Alignment": "Aliniere",
    "Alignment {0}": "",
    "All": "Tot",
    "Alternative description": "Descriere alternativ\u0103",
    "Alternative source": "Surs\u0103 alternativ\u0103",
    "Alternative source URL": "URL surs\u0103 alternativ\u0103",
    "Anchor": "Ancor\u0103",
    "Anchor...": "Ancor\u0103\u2026",
    "Anchors": "Ancore",
    "Animals and Nature": "Animale \u0219i natur\u0103",
    "Arrows": "S\u0103ge\u021bi",
    "B": "",
    "Background color": "Culoare fundal",
    "Background color {0}": "",
    "Black": "Negru",
    "Block": "Sec\u021biune",
    "Block {0}": "",
    "Blockquote": "Bloc de citate",
    "Blocks": "Blocuri",
    "Blue": "Albastru",
    "Blue component": "",
    "Body": "Corp",
    "Bold": "Aldin",
    "Border": "Chenar",
    "Border color": "Culoare chenar",
    "Border style": "Stil chenar",
    "Border width": "Grosime chenar",
    "Bottom": "Jos",
    "Browse files": "",
    "Browse for an image": "C\u0103uta\u021bi o imagine",
    "Browse links": "",
    "Bullet list": "List\u0103 marcatori",
    "Cancel": "Revocare",
    "Caption": "Titlu",
    "Cell": "Celul\u0103",
    "Cell padding": "Spa\u021biere \xeen celul\u0103",
    "Cell properties": "Propriet\u0103\u021bi celul\u0103",
    "Cell spacing": "Spa\u021biere celul\u0103",
    "Cell styles": "",
    "Cell type": "Tip celul\u0103",
    "Center": "Centru",
    "Characters": "Caractere",
    "Characters (no spaces)": "Caractere (f\u0103r\u0103 spa\u021bii)",
    "Circle": "Cerc",
    "Class": "Clas\u0103",
    "Clear formatting": "\xcendep\u0103rtare formatare",
    "Close": "\xcenchidere",
    "Code": "Cod",
    "Code sample...": "Mostr\u0103 cod\u2026",
    "Code view": "Vizualizare cod",
    "Color Picker": "Selector culori",
    "Color swatch": "Mostr\u0103 de culori",
    "Cols": "Coloane",
    "Column": "Coloan\u0103",
    "Column clipboard actions": "",
    "Column group": "Grup coloane",
    "Column header": "",
    "Constrain proportions": "Restric\u021bionare propor\u021bii",
    "Copy": "Copiere",
    "Copy column": "Copia\u021bi coloana",
    "Copy row": "Copiere r\xe2nd",
    "Could not find the specified string.": "Nu s-a g\u0103sit \u0219irul indicat.",
    "Could not load emojis": "",
    "Count": "Num\u0103r\u0103toare",
    "Currency": "Moned\u0103",
    "Current window": "Fereastra curent\u0103",
    "Custom color": "Culoare personalizat\u0103",
    "Custom...": "Particularizare...",
    "Cut": "Decupare",
    "Cut column": "T\u0103ia\u021bi coloana",
    "Cut row": "Decupare r\xe2nd",
    "Dark Blue": "Negru \xeenchis",
    "Dark Gray": "Gri \xeenchis",
    "Dark Green": "Verde \xeenchis",
    "Dark Orange": "Portocaliu \xeenchis",
    "Dark Purple": "Violet \xeenchis",
    "Dark Red": "Ro\u0219u \xeenchis",
    "Dark Turquoise": "Turcoaz \xeenchis",
    "Dark Yellow": "Galben \xeenchis",
    "Dashed": "",
    "Date/time": "Dat\u0103/or\u0103",
    "Decrease indent": "Mic\u0219orare indent",
    "Default": "Implicit",
    "Delete accordion": "",
    "Delete column": "Eliminare coloan\u0103",
    "Delete row": "Eliminare r\xe2nd",
    "Delete table": "Eliminare tabel",
    "Dimensions": "Dimensiuni",
    "Disc": "Punct",
    "Div": "Div",
    "Document": "Document",
    "Dotted": "",
    "Double": "",
    "Drop an image here": "Glisa\u021bi o imagine aici",
    "Dropped file type is not supported": "",
    "Edit": "Editare",
    "Embed": "\xcencorporare",
    "Emojis": "",
    "Emojis...": "",
    "Error": "Eroare",
    "Error: Form submit field collision.": "Eroare: Coliziune c\xe2mpuri la trimiterea formularului.",
    "Error: No form element found.": "Eroare: Niciun element de formular g\u0103sit.",
    "Extended Latin": "Simboluri alfabet latin extins",
    "Failed to initialize plugin: {0}": "Nu s-a putut ini\u021bializa modulul: {0}",
    "Failed to load plugin url: {0}": "Nu s-a putut \xeenc\u0103rca URL-ul modulului: {0}",
    "Failed to load plugin: {0} from url {1}": "Nu s-a putut \xeenc\u0103rca modulul: {0} de la URL-ul {1}",
    "Failed to upload image: {0}": "Nu s-a putut \xeenc\u0103rca imaginea: {0}",
    "File": "Fi\u0219ier",
    "Find": "G\u0103sire",
    "Find (if searchreplace plugin activated)": "C\u0103utare (dac\u0103 modulul de c\u0103utare \u0219i \xeenlocuire este activat)",
    "Find and Replace": "G\u0103si\u021bi \u0219i \xeenlocui\u021bi",
    "Find and replace...": "C\u0103utare \u0219i \xeenlocuire\u2026",
    "Find in selection": "G\u0103si\u021bi \xeen selec\u021bie",
    "Find whole words only": "G\u0103se\u0219te doar cuvintele \xeentregi",
    "Flags": "Steaguri",
    "Focus to contextual toolbar": "Centrare pe bara de unelte contextual\u0103",
    "Focus to element path": "Centrare pe calea elementului",
    "Focus to menubar": "Centrare pe bara de meniuri",
    "Focus to toolbar": "Centrare pe bara de unelte",
    "Font": "Font",
    "Font size {0}": "",
    "Font sizes": "Dimensiuni de font",
    "Font {0}": "",
    "Fonts": "Fonturi",
    "Food and Drink": "M\xe2ncare \u0219i b\u0103uturi",
    "Footer": "",
    "Format": "",
    "Format {0}": "",
    "Formats": "Formate",
    "Fullscreen": "Ecran complet",
    "G": "",
    "General": "General",
    "Gray": "Gri",
    "Green": "Verde",
    "Green component": "",
    "Groove": "",
    "Handy Shortcuts": "Comenzi rapide accesibile",
    "Header": "",
    "Header cell": "Celul\u0103 de antet",
    "Heading 1": "Titlu 1",
    "Heading 2": "Titlu 2",
    "Heading 3": "Titlu 3",
    "Heading 4": "Titlu 4",
    "Heading 5": "Titlu 5",
    "Heading 6": "Titlu 6",
    "Headings": "Rubrici",
    "Height": "\xcen\u0103l\u021bime",
    "Help": "Ajutor",
    "Hex color code": "",
    "Hidden": "Ascuns",
    "Horizontal align": "Aliniere orizontal\u0103",
    "Horizontal line": "Linie orizontal\u0103",
    "Horizontal space": "Spa\u0163iu orizontal",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID-ul trebuie s\u0103 \xeenceap\u0103 cu o liter\u0103, urmat\u0103 doar de litere, cifre, liniu\u021be, puncte, dou\u0103 puncte sau litere de subliniere.",
    "Image is decorative": "Imaginea este decorativ\u0103",
    "Image list": "List\u0103 de imagini",
    "Image title": "Titlu imagine",
    "Image...": "Imagine\u2026",
    "ImageProxy HTTP error: Could not find Image Proxy": "",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "",
    "ImageProxy HTTP error: Rejected request": "",
    "ImageProxy HTTP error: Unknown ImageProxy error": "",
    "Increase indent": "M\u0103rire indent",
    "Inline": "\xcen linie",
    "Insert": "Inserare",
    "Insert Template": "",
    "Insert accordion": "",
    "Insert column after": "Inserare coloan\u0103 dup\u0103",
    "Insert column before": "Inserare coloan\u0103 \xeenainte",
    "Insert date/time": "Inserare dat\u0103/or\u0103",
    "Insert image": "Inserare imagine",
    "Insert link (if link plugin activated)": "Inserare link (dac\u0103 modulul de link-uri este activat)",
    "Insert row after": "Inserare r\xe2nd dup\u0103",
    "Insert row before": "Inserare r\xe2nd \xeenainte",
    "Insert table": "Inserare tabel",
    "Insert template...": "Inserare \u0219ablon\u2026",
    "Insert video": "Inserare video",
    "Insert/Edit code sample": "Inserare/Editare mostr\u0103 cod",
    "Insert/edit image": "Inserare/editare imagini",
    "Insert/edit link": "Inserare/editare link",
    "Insert/edit media": "Inserare/editare media",
    "Insert/edit video": "Inserare/editare video",
    "Inset": "",
    "Invalid hex color code: {0}": "",
    "Invalid input": "",
    "Italic": "Cursiv",
    "Justify": "Aliniere st\xe2nga-dreapta",
    "Keyboard Navigation": "Navigare de la tastatur\u0103",
    "Language": "Limb\u0103",
    "Learn more...": "Afla\u021bi mai multe\u2026",
    "Left": "St\xe2nga",
    "Left to right": "St\xe2nga la dreapta",
    "Light Blue": "Albastru deschis",
    "Light Gray": "Gri deschis",
    "Light Green": "Verde deschis",
    "Light Purple": "Violet deschis",
    "Light Red": "Ro\u015fu deschis",
    "Light Yellow": "Galben deschis",
    "Line height": "\xcen\u0103l\u021bimea liniei",
    "Link list": "List\u0103 linkuri",
    "Link...": "Link\u2026",
    "List Properties": "Propriet\u0103\u021bi list\u0103",
    "List properties...": "Propriet\u0103\u021bi list\u0103...",
    "Loading emojis...": "",
    "Loading...": "A\u0219tepta\u021bi...",
    "Lower Alpha": "Litere mici",
    "Lower Greek": "Grecesc mic",
    "Lower Roman": "Cifre romane mici",
    "Match case": "Potrivire litere mari \u0219i mici",
    "Mathematical": "Simboluri matematice",
    "Media poster (Image URL)": "Poster media (URL imagine)",
    "Media...": "Media\u2026",
    "Medium Blue": "Albastru mediu",
    "Medium Gray": "Gri mediu",
    "Medium Purple": "Mov mediu",
    "Merge cells": "\xcembinare celule",
    "Middle": "Mijloc",
    "Midnight Blue": "Albastru \xeenchis",
    "More...": "Mai multe...",
    "Name": "Nume",
    "Navy Blue": "Albastru marin",
    "New document": "Document nou",
    "New window": "Fereastr\u0103 nou\u0103",
    "Next": "Urm\u0103torul",
    "No": "Nu",
    "No alignment": "F\u0103r\u0103 aliniere",
    "No color": "F\u0103r\u0103 culoare",
    "Nonbreaking space": "Spa\u021biu f\u0103r\u0103 \xeentreruperi",
    "None": "Nu se utilizeaz\u0103 (acest c\xe2mp)",
    "Numbered list": "List\u0103 numerotat\u0103",
    "OR": "SAU",
    "Objects": "Obiecte",
    "Ok": "Ok",
    "Open help dialog": "Deschide dialogul de ajutor",
    "Open link": "Deschide leg\u0103tur\u0103",
    "Open link in...": "Deschide link \xeen\u2026",
    "Open popup menu for split buttons": "Deschide\u021bi meniul pop-up pentru butoanele divizate",
    "Orange": "Portocaliu",
    "Outset": "",
    "Page break": "\xcentrerupere de pagin\u0103",
    "Paragraph": "Paragraf",
    "Paste": "Lipire",
    "Paste as text": "Lipire ca text",
    "Paste column after": "Inserare coloan\u0103 dup\u0103",
    "Paste column before": "Inserare coloan\u0103 \xeenainte",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Lipirea este \xeen mod text simplu. Con\u021binutul va fi lipit ca text simplu p\xe2n\u0103 dezactiva\u021bi aceast\u0103 op\u021biune.",
    "Paste or type a link": "Lipi\u021bi sau scrie\u021bi un link",
    "Paste row after": "Lipire r\xe2nd dup\u0103",
    "Paste row before": "Lipire r\xe2nd \xeenainte",
    "Paste your embed code below:": "Lipi\u021bi codul de \xeencorporare mai jos:",
    "People": "Persoane",
    "Plugins": "Inserturi",
    "Plugins installed ({0}):": "Module instalate ({0}):",
    "Powered by {0}": "Sus\u021binut de {0}",
    "Pre": "Pre",
    "Preferences": "Preferin\u021be",
    "Preformatted": "Preformatat",
    "Premium plugins:": "Module premium:",
    "Press the Up and Down arrow keys to resize the editor.": "Ap\u0103sa\u021bi tastele Sus \u0219i Jos pentru a redimensiona editorul.",
    "Press the arrow keys to resize the editor.": "Ap\u0103sa\u021bi tastele s\u0103geat\u0103 pentru a redimensiona editorul.",
    "Press {0} for help": "",
    "Preview": "Previzualizare",
    "Previous": "Anterior",
    "Print": "Imprimare",
    "Print...": "Tip\u0103rire\u2026",
    "Purple": "Mov",
    "Quotations": "Ghilimele",
    "R": "",
    "Range 0 to 255": "",
    "Red": "Ro\u0219u",
    "Red component": "",
    "Redo": "Refacere",
    "Remove": "\u0218terge",
    "Remove color": "Eliminare culoare",
    "Remove link": "Eliminare link",
    "Replace": "\xcenlocuire",
    "Replace all": "\xcenlocuire peste tot",
    "Replace with": "\xcenlocuire cu",
    "Resize": "Redimensionare",
    "Restore last draft": "Restabili\u021bi ultima ciorn\u0103",
    "Reveal or hide additional toolbar items": "",
    "Rich Text Area": "",
    "Rich Text Area. Press ALT-0 for help.": "Zon\u0103 Text Formatat. Ap\u0103sa\u021bi ALT-0 pentru ajutor.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Zon\u0103 Text Formatat. Ap\u0103sa\u021bi ALT-F9 pentru a accesa meniul. Ap\u0103sa\u021bi ALT-F10 pentru a accesa bara de unelte. Ap\u0103sa\u021bi ALT-0 pentru ajutor",
    "Ridge": "",
    "Right": "Dreapta",
    "Right to left": "Dreapta la st\xe2nga",
    "Row": "R\xe2nd",
    "Row clipboard actions": "Ac\u021biuni clipboard pe r\xe2nd",
    "Row group": "Grupare r\xe2nduri",
    "Row header": "",
    "Row properties": "Propriet\u0103\u021bi r\xe2nd",
    "Row type": "Tip r\xe2nd",
    "Rows": "R\xe2nduri",
    "Save": "Salvare",
    "Save (if save plugin activated)": "Salvare (dac\u0103 modulul de salvare este activat)",
    "Scope": "Domeniu",
    "Search": "C\u0103utare",
    "Select all": "Selecteaz\u0103 tot",
    "Select...": "Selectare...",
    "Selection": "Selec\u021bie",
    "Shortcut": "Comand\u0103 rapid\u0103",
    "Show blocks": "Arat\u0103 rubricile",
    "Show caption": "Afi\u0219are captur\u0103",
    "Show invisible characters": "Arat\u0103 caracterele invizibile",
    "Size": "Dimensiuni",
    "Solid": "",
    "Source": "Surs\u0103",
    "Source code": "Cod surs\u0103",
    "Special Character": "Caracter special",
    "Special character...": "Caracter special\u2026",
    "Split cell": "Scindare celul\u0103",
    "Square": "P\u0103trat",
    "Start list at number": "\xcencepe\u021bi lista la num\u0103rul",
    "Strikethrough": "T\u0103iere",
    "Style": "Stil",
    "Subscript": "Indice",
    "Superscript": "Exponent",
    "Switch to or from fullscreen mode": "Comutare pe sau de la modul ecran complet",
    "Symbols": "Simboluri",
    "System Font": "Font Sistem",
    "Table": "Tabel",
    "Table caption": "",
    "Table properties": "Propriet\u0103\u021bi tabel",
    "Table styles": "",
    "Template": "\u0218ablon",
    "Templates": "\u0218abloane",
    "Text": "",
    "Text color": "Culoare text",
    "Text color {0}": "",
    "Text to display": "Text de afi\u0219at",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "URL-ul introdus pare a fi o adres\u0103 de e-mail. Dori\u021bi s\u0103 ad\u0103uga\u021bi prefixul mailto: necesar?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "URL-ul introdus pare a fi un link extern. Dori\u021bi s\u0103 ad\u0103uga\u021bi prefixul http:// necesar?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "Adresa URL pe care a\u021bi introdus-o pare a fi un leg\u0103tur\u0103 extern\u0103. Dori\u021bi s\u0103 ad\u0103uga\u021bi prefixul https:// necesar?",
    "Title": "Titlu",
    "To open the popup, press Shift+Enter": "Pentru a deschide fereastra popup, ap\u0103sa\u021bi Shift+Enter",
    "Toggle accordion": "",
    "Tools": "Unelte",
    "Top": "Sus",
    "Travel and Places": "C\u0103l\u0103torii \u0219i loca\u021bii",
    "Turquoise": "Turcoaz",
    "Underline": "Subliniere",
    "Undo": "Anulare",
    "Upload": "\xcenc\u0103rcare",
    "Uploading image": "\xcenc\u0103rcare imagine",
    "Upper Alpha": "Litere mari",
    "Upper Roman": "Cifre romane mari",
    "Url": "Url",
    "User Defined": "Definite de utilizator",
    "Valid": "",
    "Version": "Versiune",
    "Vertical align": "",
    "Vertical space": "Spa\u0163iu vertical",
    "View": "Vizualizare",
    "Visual aids": "Ajutoare vizuale",
    "Warn": "Aten\u021bionare",
    "White": "Alb",
    "Width": "L\u0103\u021bime",
    "Word count": "Num\u0103r\u0103toare cuvinte",
    "Words": "Cuvinte",
    "Words: {0}": "Cuvinte: {0}",
    "Yellow": "Galben",
    "Yes": "Da",
    "You are using {0}": "Folosi\u021bi {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Ave\u021bi modific\u0103ri nesalvate. Sigur dori\u021bi s\u0103 naviga\u021bi \xeen alt\u0103 parte?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Browser-ul dumneavoastr\u0103 nu are acces direct la clipboard. V\u0103 rug\u0103m s\u0103 folosi\u021bi \xeen schimb scurt\u0103turile de tastatur\u0103 Ctrl+X/C/V.",
    "alignment": "aliniere",
    "austral sign": "simbol austral",
    "cedi sign": "simbol cedi",
    "colon sign": "dou\u0103 puncte",
    "cruzeiro sign": "simbol cruzeiro",
    "currency sign": "simbol moned\u0103",
    "dollar sign": "simbol dolar",
    "dong sign": "simbol dong",
    "drachma sign": "simbol drahm\u0103",
    "euro-currency sign": "simbol euro",
    "example": "exemplu",
    "formatting": "formatare",
    "french franc sign": "simbol franc francez",
    "german penny symbol": "simbol peni german",
    "guarani sign": "simbol guarani",
    "history": "istoric",
    "hryvnia sign": "simbol grivn\u0103",
    "indentation": "indentare",
    "indian rupee sign": "simbol rupie indian\u0103",
    "kip sign": "simbol kip",
    "lira sign": "simbol lir\u0103",
    "livre tournois sign": "simbol livr\u0103 tournois",
    "manat sign": "simbol manat",
    "mill sign": "simbol mill",
    "naira sign": "simbol naira",
    "new sheqel sign": "simbol shekel nou",
    "nordic mark sign": "simbol marc\u0103 nordic\u0103",
    "peseta sign": "simbol peset\u0103",
    "peso sign": "simbol peso",
    "ruble sign": "simbol rubl\u0103",
    "rupee sign": "simbol rupie",
    "spesmilo sign": "simbol spesmilo",
    "styles": "stiluri",
    "tenge sign": "simbol tenge",
    "tugrik sign": "simbol tugrik",
    "turkish lira sign": "simbol lir\u0103 turceasc\u0103",
    "won sign": "simbol won",
    "yen character": "simbol yen",
    "yen/yuan character variant one": "simbol yen/yuan prima variant\u0103",
    "yuan character": "simbol yuan",
    "yuan character, in hong kong and taiwan": "simbol yuan \xeen Hong Kong \u0219i Taiwan",
    "{0} characters": "{0} caractere",
    "{0} columns, {1} rows": "{0} coloane, {1} r\xe2nduri",
    "{0} words": "{0} cuvinte"
});